// Core
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Box, Button, Flex, Text, Grid, Divider, Image, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { useHistory, useParams, NavLink } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { formatDateTicket, validateLoadMore } from 'services/Utils';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

// Components
import { StarsIcon } from 'components/Icons/Icons';
import Card from 'components/Card/Card';

const SupportTicket = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const border = useColorModeValue('1px solid #CBE7FF', '1px solid #0a1025');
  const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');

  const limit = 10;
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [dataMeta, setDataMeta] = useState(); 

  const { isLoading } = useQuery({
      queryKey: ['tickets', offset],
      queryFn: async () => {
          const response = await apiService.getTickets({ limit, offset });

          if(offset === 0){
              setData(response.data);
          } else {
              setData([...data, ...response.data]);
          }
          setDataMeta(response.meta);
          return true;
      },
      refetchOnWindowFocus: false
  });

  const loadMore = async () => {
      setOffset(offset + limit);
  };

  const history = useHistory();
  const handlePage = (id) => {
    history.push(`/contact-support/${id}`); 
  };

  return (
    <>
      { isDark ? (
        <>
        <Lines className="abstract-lines" style={{transform: 'rotate(338deg)', top: '40px', left: '-20%'}}  />
        <Lines className="abstract-lines" style={{transform: 'rotate(338deg)', top: '40px', left: '50%'}} />
        </>
        ) : (
        <>
        <LinesWhite className="abstract-lines" style={{transform: 'rotate(338deg)', top: '40px', left: '-20%', opacity: 0.3 }}  />
        <LinesWhite className="abstract-lines" style={{transform: 'rotate(338deg)', top: '40px', left: '50%', opacity: 0.3 }} />
        </>
      )}

      <Box m="37px auto 100px auto">
        <Flex gap="26px" m={{base: '40px 0 46px 0', md: '82px 0 46px 0'}} textAlign="center" w="100%" alignItems="center" justifyContent="center">
          <StarsIcon fontSize={{base: '28px', md: '43px'}} />
          <Text variant="header" fontSize={{base: '46px', md: '64px', lg: '72px'}}>Request history</Text>
          <StarsIcon fontSize={{base: '28px', md: '43px'}} />
        </Flex>

        <Box position="relative">
          { data?.length > 0 && data.map((item, index) => (
            <Card onClick={() => handlePage(item?.id)} border={border} boxShadow={boxShadow} borderRadius="8px" key={index} padding="12px 8px" mb="16px" cursor="pointer">
              <Flex gap="4px">
                <Text variant="text-sm" color="#9FABCB" fontSize="13px">Status: </Text>
                <Text 
                  variant="text-sm" 
                  color={
                    item?.status === 'new' ? '#FFB91B' :
                    item?.status === 'in_progress' ? '#57D175' :
                    item?.status === 'closed' ? '#FF6C64' : '#8C99ED'
                  }
                  fontSize="13px">
                  {
                    item?.status === 'new' ? 'New' :
                    item?.status === 'in_progress' ? 'In Progress' :
                    item?.status === 'closed' ? 'Closed' : 'Resolved'
                  }
                </Text>
              </Flex>

              <Text variant="title-md" fontWeight="700" mt="8px">{item?.title}</Text>

              <Text fontSize="15px" mt="4px">
                <span style={{ color: '#099BFF'}}>[{ item?.lastMessage?.user?.firstName }] </span>
                { item?.lastMessage?.message }
              </Text>

              <Text variant="text-xs" mt="4px">{formatDateTicket(item?.lastMessage?.createdAt)}</Text>
            </Card>
          ))}

          { validateLoadMore(data, dataMeta) && (
              <Button variant="ghost-md" maxW="220px" onClick={loadMore} m="24px auto" display="block">
                Load More
              </Button>
          )}

          <NavLink to="/contact-support/create-ticket">
            <Button 
              variant={ isDark ? 'button-lg-g' : 'button-lg' }
              w="280px" 
              left="50%"
              transform="translate(-50%, 24px)">
              Create ticket</Button>
          </NavLink>
        </Box>
      </Box>
    </>
  );
};

export default SupportTicket;